// Barrel Export für HL-Area-Komponenten
export { HlAreaDirective } from './hl-area.directive';
export { HlAreaComponent } from './hl-area.component';
export { HlAreaContainerComponent } from './hl-area-container.component';
export { AdresseComponent } from './adresse.component';
export { AufnahmeComponent } from './aufnahme.component';
export { BodenComponent } from './boden.component';
export { KurzprotokollComponent } from './kurzprotokoll.component';
export { NaturraumComponent } from './naturraum.component';
export { SubstrateHorizonteComponent } from './substrate-horizonte.component';
export { BaumartenComponent } from './baumarten.component';
export { BestandComponent } from './bestand.component';
export { VegetationsaufnahmeComponent } from './vegetationsaufnahme.component';
